var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegularPcOrLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    rx: 45,
    fill: "url(#paint0_linear_278_3837)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.2798 55.8747H67.3033V31.261C67.3033 29.3843 65.7764 27.8574 63.8996 27.8574H26.109C24.2322 27.8574 22.7054 29.3842 22.7054 31.261V55.8746H20.7191C19.9284 55.8747 19.2852 56.518 19.2852 57.3087V60.3394C19.2852 61.7501 20.4329 62.8978 21.8435 62.8978H29.0465C29.4627 62.8978 29.8 62.5605 29.8 62.1443C29.8 61.7282 29.4627 61.3909 29.0465 61.3909H21.8435C21.2637 61.3909 20.7921 60.9192 20.7921 60.3394V57.3816H39.4883L40.0472 58.9764C40.2911 59.6722 40.9502 60.1396 41.6875 60.1396H48.3211C49.0584 60.1396 49.7175 59.6721 49.9614 58.9764L50.5203 57.3816H69.2069V60.3394C69.2069 60.9192 68.7352 61.3909 68.1555 61.3909H32.4921C32.0759 61.3909 31.7386 61.7282 31.7386 62.1443C31.7386 62.5605 32.0759 62.8978 32.4921 62.8978H68.1554C69.566 62.8978 70.7137 61.7501 70.7137 60.3394V57.3087C70.7137 56.518 70.0705 55.8747 69.2798 55.8747ZM48.5392 58.4781C48.5068 58.5707 48.4191 58.6328 48.321 58.6328H41.6874C41.5894 58.6328 41.5017 58.5706 41.4693 58.4781L41.0849 57.3816H48.9233L48.5392 58.4781ZM65.7964 55.8747H63.8493V32.6234C63.8493 31.8853 63.2489 31.2849 62.5107 31.2849H53.5934C53.1773 31.2849 52.84 31.6222 52.84 32.0383C52.84 32.4545 53.1773 32.7918 53.5934 32.7918H62.3424V55.8747H27.6662V32.7918H50.0607C50.4769 32.7918 50.8142 32.4545 50.8142 32.0383C50.8142 31.6222 50.4769 31.2849 50.0607 31.2849H27.498C26.7599 31.2849 26.1594 31.8853 26.1594 32.6234V55.8746H24.2123V31.261C24.2123 30.2152 25.0631 29.3643 26.109 29.3643H63.8996C64.9455 29.3643 65.7964 30.2152 65.7964 31.261V55.8747Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_278_3837",
    x1: 45,
    y1: 0,
    x2: 45,
    y2: 90,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056FB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegularPcOrLaptop);
export default __webpack_public_path__ + "static/media/Regular-PC-or-Laptop.252a5df08617214a0bb0e3f686136b1e.svg";
export { ForwardRef as ReactComponent };